import * as React from "react";
import { useTranslation } from "react-i18next";
import QueryHelper from "components/common/QueryHelper";
const EXAMPLE_QUERY = "name:manager";
const RolesQueryHelper = () => {
  const { t } = useTranslation("users");
  const queryExample = /* @__PURE__ */ React.createElement("p", null, t("roles.query_example"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, EXAMPLE_QUERY), /* @__PURE__ */ React.createElement("br", null));
  return /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "role", example: queryExample, commonFields: ["name", "description"] });
};
export default RolesQueryHelper;
